/**
 * ReportResultsTable — generic tabular results for non-DSU reports.
 * Stage 3 UI extraction from ReportsPage.js
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { REPORTS } from '../../hooks/reports/reportConstants';

const ReportResultsTable = ({ activeReport, data, rows, visibleCols, allFieldsForReport, filters, renderCell }) => {
  if (!data || activeReport === 'daily-sale-updates' || !visibleCols.length) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          {REPORTS.find(r => r.id === activeReport)?.label}
          {activeReport === 'sales-performance' && ` — By ${filters.group_by?.charAt(0).toUpperCase() + filters.group_by?.slice(1)}`}
        </CardTitle>
        <p className="text-xs text-muted-foreground">{rows.length} results • {visibleCols.length} of {allFieldsForReport().length} fields shown</p>
      </CardHeader>
      <CardContent className="px-4 py-0 pb-4">
        <Table>
          <TableHeader>
            <TableRow>
              {visibleCols.map(f => <TableHead key={f.key}>{f.label}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow><TableCell colSpan={visibleCols.length} className="text-center py-8 text-muted-foreground">No data</TableCell></TableRow>
            ) : rows.map((row, i) => (
              <TableRow key={row.id || row.opportunity_id || row.account_id || row.invoice_id || i}>
                {visibleCols.map(f => (
                  <TableCell key={f.key} className="text-sm">{renderCell(row, f)}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default ReportResultsTable;
